import { GIPHY_PREDICTIONS } from '@mm/api-routes';
import Controller from './Controller';

type GifImageProperties = {
  height: string;
  mp4: string;
  mp4Size: string;
  size: string;
  url: string;
  webp: string;
  webpSize: string;
  width: string;
};

export type GifResponse = {
  id: string;
  title: string;
  images: {
    fixedWidth: GifImageProperties;
    [key: string]: GifImageProperties;
  };
  [key: string]: any;
};

type ExtendedBlob = Blob & {
  name?: string;
};

export default class GifController extends Controller {
  static getPredictions(
    searchPhrase: string,
  ): Promise<{ data: GifResponse[] }> {
    return super.get(GIPHY_PREDICTIONS(searchPhrase));
  }

  static async downloadGif(url: string): Promise<ExtendedBlob> {
    const request = new Request(url, {
      method: 'GET',
      responseType: 'blob',
    } as any);
    const response = await fetch(request);
    const blob = await response.blob();
    return blob;
  }
}
